<template>
  <div>
    <div class="caption-join body">
      <div id="language-select">
        <input type="text" v-model="sessionName" placeholder="Session Name"  style="width:120px;" />
        <select v-model="toLanguageCode" style="width:60px;">
          <option v-for="lang in toLanguageCodes" :value="lang" :key="lang">
            {{ lang }}
          </option>
        </select>
      </div>
      <div id="captions-text" class="caption">
        <div v-for="caption in captions" :key="caption.offset">{{ caption.text }}</div>
      </div>
    </div>
    <div class="footer">
        <center>Copyright by Moresi.com SA 2022 - Powered by Microsoft Azure Services - <a href="/credits">Credits</a></center>
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import constants from '../lib/constants'
import * as signalR from '@aspnet/signalr'
import languageListMixin from '../lib/language-list-mixin'

export default {
  mixins: [languageListMixin],
  props: {
    clientId: String
  },
  data() {
    return {
      code: '',
      captions: [],
      toLanguageCode: 'en',
      sessionName: ''
    }
  },
  computed: {
    toLanguageCodes() {
      return this.toLanguages.map(l => l.substring(0, 2)).sort()
    }
  },
  methods: {
    async updateLanguageSubscription(languageCode) {
      if (this.sessionName && languageCode) {

        await axios.post(`${constants.apiBaseUrl}/api/leave`, {
          userId: this.clientId,
        });

        await axios.post(`${constants.apiBaseUrl}/api/selectlanguage`, {
          languageCode,
          userId: this.clientId,
          sessionName: this.sessionName
        });
      }
    }
  },
  watch: {
    toLanguageCode: {
      handler() {
        return this.updateLanguageSubscription(this.toLanguageCode)
      },
      immediate: true
    },
    sessionName: {
      handler() {
        return this.updateLanguageSubscription(this.toLanguageCode)
      }
    }
  },
  async mounted() {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${constants.apiBaseUrl}/api/${this.clientId}`)
      .build()

    this.connection.on('newCaption', onNewCaption.bind(this))

    await this.connection.start()
    console.log('connection started')

    const captionsMap = {}
    var final = false;
    function onNewCaption(caption) {
      console.log(caption);
      let localCaption = captionsMap[caption.offset]
      if (!localCaption) {
        localCaption = captionsMap[caption.offset] = {
          offset: caption.offset,
          text: ''
        }

        if (!final) {
          this.captions.pop();
        }

        if (caption.reason === "TranslatedSpeech") {
          this.captions.pop();
          final = true;
        }


        this.captions.push(localCaption)
      }
      localCaption.text = caption.text

      Vue.nextTick(function () {
        window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight)
      })
    }
  },
  async beforeDestroy() {
    if (this.connection) {
      await Promise.all([
        this.connection.stop(),
        this.updateLanguageSubscription(null)
      ])
      console.log('connection stopped')
    }
  }
}
</script>

<style scoped>
#language-select {
  position: fixed;
  top: 0;
  width: 100%;
  padding-top: 95px;
  padding-bottom: 6px;
  background-color: white;
}

#captions-text {
  padding-top: 140px;
  padding-bottom: 60px
}

.footer {
  height: 20%;
  margin-top: 20px;
  bottom: 0;
  padding: 10px;
}

.footer img {
  width: 20%;
}
</style>
